export default {
  methods: {
    checkPerm(perm) {
      // if(this.perms.has(perm)) return
      // let {crmAvaliablePerms} = this.$store.getters['user/current']
      // this.$router.push({name: crmAvaliablePerms[0]})
    }
  }
}